// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__zioHp","signatureButtonsRight":"ModalSign_signatureButtonsRight__2DcdD"};